import React, {useState, useMemo} from 'react';
import FactureView from './FactureView';
import {deleteFacture} from '../../../services/MadricService';
import './Facture.css';
import swal from 'sweetalert';

/**
 * Permet d'ajouter ou de modifier une facture
 * @param {*} props props
 * @return {JSX}
 */
function Facture(props) {
  const [searchInput, setSearchInput] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 18;

  const filteredFactures = useMemo(() => {
    return props.factures
        .filter((facture) =>
          searchInput
              .toLowerCase()
              .split(' ')
              .every(
                  (term) =>
                    facture.name.toLowerCase().includes(term),
              ),
        );
  }, [searchInput, props.factures]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, filteredFactures.length);

  const displayedFactures = filteredFactures.slice(startIndex, endIndex);


  /**
   * Permet de gérer la searchBar
   * @param {*} e event
   */
  function handleSearchInput(e) {
    setSearchInput(e.target.value);
    setCurrentPage(1);
  }

  /**
   * Permet de changer de page
   * @param {*} newPage la page à afficher
   */
  function handlePageChange(newPage) {
    setCurrentPage(newPage);
  }

  const isButtonDisabled = (symbol) => {
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === Math.ceil(filteredFactures.length / pageSize) || filteredFactures.length === 0;
    return symbol.props.icon.iconName === 'angles-left' || symbol.props.icon.iconName === 'angle-left' ? isFirstPage : isLastPage;
  };

  /**
   * Permet de supprimer une facture
   * @param {*} facture La facture
   */
  async function supprimer(facture) {
    swal({
      title: 'Êtes-vous sûre de vouloir supprimer ' + facture.name,
      text: 'Une fois supprimer vous n\'y aurai plus accès',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });
            props.setFactures((prevItems) => prevItems.filter((item) => item.id !== facture.id));
            await deleteFacture(facture.id);
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <div>
      <FactureView
        searchInput={searchInput}
        handleSearchInput={handleSearchInput}
        handlePageChange={handlePageChange}
        isButtonDisabled={isButtonDisabled}
        displayedFactures={displayedFactures}
        supprimer={supprimer}
        factures={props.factures}
        setFactures={props.setFactures}
        pageSize={pageSize}
        currentPage={currentPage} />
    </div>
  );
}

export default Facture;
